export class AdminApiError extends Error {
  constructor(
    public readonly code: string,
    message: string,
    public readonly retryable = false,
    public readonly safeDetails?: Record<string, unknown>,
  ) {
    super(message);
    this.name = "AdminApiError";
  }
}

/**
 * Convert internal/API failures into stable, user-safe UI copy.
 * Raw provider, transport and Backend messages must never be rendered directly.
 */
export function toSafeAdminErrorMessage(error: unknown): string {
  if (error instanceof AdminApiError) {
    switch (error.code) {
      case "invalid_credentials":
      case "authentication_failed":
        return "core.errors.invalid_credentials";
      case "mfa_required":
        return "core.errors.mfa_required";
      case "reauthentication_required":
        return "core.errors.reauthentication_required";
      case "access_denied":
      case "permission_denied":
      case "forbidden":
        return "core.errors.access_denied";
      case "session_expired":
      case "unauthenticated":
        return "core.errors.session_expired";
      case "rate_limited":
      case "too_many_requests":
        return "core.errors.rate_limited";
      case "validation_failed":
      case "invalid_request":
        return "core.errors.validation_failed";
      case "not_found":
        return "core.errors.not_found";
      default:
        return error.retryable
          ? "core.errors.retryable"
          : "core.errors.generic";
    }
  }

  if (error instanceof Error && error.message.startsWith("PLATFORM_ADMIN_AUTH_BRIDGE_NOT_INSTALLED:")) {
    return "core.errors.auth_bridge_missing";
  }

  return "core.errors.unexpected";
}
